import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  actionButtons: {
    width: 74,
    "& > button": {
      display: "inline-block",
      "&:first-child": {
        marginRight: 10,
      },
    },
  },
}));

export default useStyles;
